export function getYMDHMSFormatDTString(date: any) {
  var time = new Date(date);
  time.setHours(time.getHours() + 9);
  return time.toISOString().replace("T", " ").substring(0, 19);
}

export function getYMDFormatDTString(date: any) {
  var time = new Date(date);
  time.setHours(time.getHours() + 9);
  return time.toISOString().replace("T", " ").substring(0, 10);
}

export function getYMFormatDTString(date: any) {
  var time = new Date(date);
  time.setHours(time.getHours() + 9);
  return time.toISOString().replace("T", " ").substring(0, 7);
}

export function getMDFormatDTString(date: any) {
  var time = new Date(date);
  time.setHours(time.getHours() + 9);
  return time.toISOString().replace("T", " ").substring(5, 10);
}

export function getYMDWFormatDTString(date: any) {
  var time = new Date(date);
  // time.setHours(time.getHours() + 9);
  // console.log("time", time)
  let daysOfWeek: string[] = [
    "(일)",
    "(월)",
    "(화)",
    "(수)",
    "(목)",
    "(금)",
    "(토)",
  ];
  let dOW = daysOfWeek[time.getDay()];
  return time.toISOString().replace("T", " ").substring(0, 10) + " " + dOW;
}

// 입력한 날부터 일주일 전까지 YMDHMS
export function getBetween7Date(date: any) {
  let startDate = new Date(date);
  startDate.setDate(startDate.getDate() - 6);
  let endDate = new Date(date);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);
  return {
    startDate: getYMDHMSFormatDTString(startDate),
    endDate: getYMDHMSFormatDTString(endDate),
  };
}

// 입력한 날부터 일주일 전까지 YMD
export function getYMDBetween7Date(date: any) {
  let startDate = new Date(date);
  startDate.setDate(startDate.getDate() - 6);
  let endDate = new Date(date);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);
  return {
    startDate: getYMDFormatDTString(startDate),
    endDate: getYMDFormatDTString(endDate),
  };
}

// 입력한 날부터 일주일 전까지 MD
export function getMDBetween7Date(date: any) {
  let startDate = new Date(date);
  startDate.setDate(startDate.getDate() - 6);
  let endDate = new Date(date);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);
  return {
    startDate: getMDFormatDTString(startDate),
    endDate: getMDFormatDTString(endDate),
  };
}
// 입력한 기간 사이의 날짜들
export function getPeriodDates(startDate: string, endDate: string) {
  var moment = require("moment");

  const resArray: string[] = [];
  let cur = new Date(startDate);
  let end = new Date(endDate);

  while (true) {
    if (cur > end) {
      break;
    }
    resArray.push(moment(cur).format("yyyy-MM-DD"));
    cur.setDate(cur.getDate() + 1);
  }

  return resArray;
}

// 입력한 기간과 같은 기간의 시작과 끝날 끝날은 입력한 기간의 시작 전날(날짜)
export function getPrevDatePeriod(startDate: any, endDate: any) {
  var moment = require("moment");

  let curStart = new Date(startDate);
  let curEnd = new Date(endDate);

  curStart.setHours(0, 0, 0, 0);
  curEnd.setHours(23, 59, 59, 999);

  if (
    curStart.getFullYear() == curEnd.getFullYear() &&
    curStart.getMonth() == curEnd.getMonth() &&
    curStart.getDate() == curEnd.getDate()
  ) {
    let prevStart = new Date(curStart);
    let prevEnd = new Date(curEnd);
    prevStart.setDate(prevStart.getDate() - 1);
    prevEnd.setDate(prevEnd.getDate() - 1);
    return {
      startDate: moment(prevStart).format("yyyy-MM-DD"),
      endDate: moment(prevEnd).format("yyyy-MM-DD"),
    };
  }

  let prevEnd = new Date(curStart);
  prevEnd.setDate(prevEnd.getDate() - 1);
  let diff = Math.ceil(
    (curEnd.getTime() - curStart.getTime()) / (1000 * 3600 * 24)
  );
  let prevStart = new Date(prevEnd);
  prevStart.setDate(prevStart.getDate() - diff + 1);
  prevEnd.setHours(23, 59, 59, 999);
  return {
    startDate: moment(prevStart).format("yyyy-MM-DD"),
    endDate: moment(prevEnd).format("yyyy-MM-DD"),
  };
}

// 입력한 기간 사이의 날짜들(월))
export function getPeriodMonths(startDate: any, endDate: any) {
  const res: any[] = [];
  let cur = new Date(startDate);
  cur.setDate(1);
  let end = new Date(endDate);

  while (true) {
    if (cur > end) {
      break;
    }
    res.push(getYMFormatDTString(cur));
    cur.setMonth(cur.getMonth() + 1);
  }
  return res;
}

export function is1YearOver(startD: any) {
  let endDate = new Date();
  let startDate = new Date(startD);

  const betweenDay = Math.floor(
    (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
  );
  console.log(startDate, betweenDay, endDate);
  if (betweenDay > 365) {
    alert(startDate + "는 1년 전입니다");
    return true;
  }
  alert(startDate + "는 1년 전이 아닙니다");

  return false;
}

export function getDayAbbrStr(date: any) {
  const d = new Date(date);
  const weekday = ["일", "월", "화", "수", "목", "금", "토"];
  return weekday[d.getDay()];
}
